import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'takeFirstLetter',
})
export class AvatarTakeFirstLetterPipe implements PipeTransform {
  transform(value: string | null): string {
    if (value) {
      return value.substring(0, 1);
    }

    return '';
  }
}
